/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import { ArrowDownIcon } from "@smartsheet/lodestar-icons";
import { components } from "react-select";
import { neutral } from "../../../constants/colors";
import { sizes } from "../../../constants/spacing";

/**
 * @deprecated This component is being removed in V6+, February 2025, in favor of the `SelectV2/MultiSelectV2` components.
 */
export const DropdownIndicator: typeof components.DropdownIndicator = (props) => (
    <components.DropdownIndicator
        {...props}
        css={css`
            ${props.selectProps.isDisabled
                ? `
                    color: ${neutral};
                    &:hover {
                        color: ${neutral};
                    }
                `
                : `
                    color: inherit;
                    &:hover {
                        color: inherit;
                    }
                `}
            padding: 0 ${sizes.xSmall}px;
        `}
    >
        <ArrowDownIcon aria-label="open" />
    </components.DropdownIndicator>
);
